<template>
  <div class="animated fadeIn">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <label>Start Date</label>
              <kendo-datepicker class="form-control" v-model="startDate" format="dd-MM-yyyy"></kendo-datepicker>
            </div>
            <div class="col-12 col-md-6">
              <label>End Date</label>
              <kendo-datepicker class="form-control" v-model="endDate" format="dd-MM-yyyy"></kendo-datepicker>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <div class="btn-group">
            <button class="btn btn-secondary" type="button" @click="refreshChart">
              Get Report!
            </button>
            <button type="button" class="btn btn-lg btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" @click="exportData">Export Data</button>
            </div>
          </div>
        </div>
      </div>
      <kendo-pivotdatasource ref="salesreport"
          :transport-read="salesPivot"
          :schema-cube="pivot.schema"
          :measures="pivot.measures">
        <kendo-pivot-column :name="'type'"></kendo-pivot-column>
        <kendo-pivot-row :name="'product'"></kendo-pivot-row>
      </kendo-pivotdatasource>
      <div class="row m-0">
        <kendo-pivotconfigurator id="configurator"
            class="d-none d-md-block col-md-2 p-0"
            :data-source-ref="'salesreport'"
            :filterable="true"
            :height="600">
        </kendo-pivotconfigurator>
        <kendo-pivotgrid id="pivotgrid"
            class="col-12 col-md-10 p-0"
            :data-source-ref="'salesreport'"
            :filterable="true"
            :orderable="true"
            :columnWidth="200"
            :height="600">
        </kendo-pivotgrid>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      // data here
      startDate: moment().subtract(parseInt(moment().format('DD')) - 1, 'days').format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      pivot: {
        measures: ['Gross Sales'],
        schema: {
          dimensions: {
            type: { caption: 'Sales Type' },
            channel: { caption: 'Channel' },
            product: { caption: 'Product' }
          },
          measures: {
            'Gross Sales': { field: 'sales', aggregate: 'sum', format: '{0:c}' },
            'Quantity': { field: 'quantity', aggregate: 'sum', format: '{0:n}' }
          }
        }
      },
      sales: {
        series: [
          {
            name: 'Retail',
            field: 'retail',
            categoryField: 'date',
            type: 'line',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                if (parseInt(e.text) > 10) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Reseller',
            field: 'reseller',
            categoryField: 'date',
            type: 'line',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                if (parseInt(e.text) > 10) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Consignment',
            field: 'consignment',
            categoryField: 'date',
            type: 'line',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                // only display value that are more than 10 Million
                if (parseInt(e.text) > 0) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Dropship',
            field: 'dropship',
            categoryField: 'date',
            type: 'line',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                if (parseInt(e.text) > 10) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Total Sales',
            field: 'total',
            categoryField: 'date',
            type: 'column',
            color: '#E9E9E9',
            tooltip: false,
            labels: {
              visible: true,
              color: '#848484',
              font: '10px Roboto !important',
              template: '# kendo.culture("en-US") # #= kendo.toString(Number(value / 1000000), "n") #',
              visual: function (e) {
                if (parseInt(e.text) > 0) {
                  return e.createVisual()
                }
              }
            }
          }
        ],
        title: {
          text: 'SALES PERFOMANCE CURRENT MONTH (VALUE IN MILLION)',
          align: 'left',
          color: '#000',
          font: '14px inherit !important'
        },
        legend: {
          position: 'right',
          offsetX: -100,
          offsetY: -150,
          orientation: 'vertical',
          labels: {
            font: '10px Roboto !important'
          }
        },
        tooltip: {
          visible: true,
          background: 'green',
          font: '14px Roboto !important',
          template: '#= series.name.toUpperCase() #:  #= kendo.toString(Number(value / 1000000).toFixed(2)) #M&nbsp;&nbsp;&nbsp;(#= category.getDate() + "/" + (category.getMonth() +1).toString() #)'
        },
        chartArea: {
          background: '#FFFFFF',
          margin: {
            right: -100
          }
        },
        schema: {
          data: 'data',
          parse: function (response) {
            var data = []
            var i = 0
            while (i < response.data.length) {
              var temp = response.data[i]
              var date = temp['date']
              var momentDate = moment(date)
              var report = {
                date: new Date(parseInt(momentDate.format('YYYY')), parseInt(momentDate.format('MM')) - 1, parseInt(momentDate.format('DD')))
              }
              var total = 0
              while (i < response.data.length && date === temp['date']) {
                report[temp['sales_type'].toLowerCase()] = Number(temp['sale'])
                total += Number(temp['sale'])
                temp = response.data[++i]
              }
              report['total'] = total
              data.push(report)
            }
            response.data = data
            return response
          }
        },
        valueAxis: {
          labels: {
            visible: false,
            border: {
              color: 'transparent'
            },
            color: '#848484',
            font: '10px Roboto !important',
            template: '#= kendo.toString(value / 1000000) #M'
          },
          line: {
            visible: false,
            color: 'transparent',
            width: 0
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        },
        categoryAxis: {
          color: '#000',
          labels: {
            font: '12px Roboto !important',
            dateFormats: {
              days: 'dd'
            }
          },
          baseUnit: 'days',
          line: {
            color: '#EAEAEA'
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        }
      }
    }
  },
  created () {
    // set culture
    window.kendo.culture('id-ID')
  },
  methods: {
    refreshChart () {
      console.log('refreshing chart ..')
      console.log(this.$refs.salesreport)
      this.$refs.salesreport.kendoDataSource.read()
    },
    salesReport (event) {
      var vm = this
      vm.axios.get('api/report/sales/types/?date=' + encodeURIComponent(moment(vm.startDate, 'DD-MM-YYYY').format('YYYYMMDD') + ';' + moment(vm.endDate, 'DD-MM-YYYY').format('YYYYMMDD')))
        .then(
          (response) => {
            console.log(response)
            event.success(response)
          }
        )
    },
    salesPivot (event) {
      var vm = this
      vm.axios.get('api/report/sales/pivot/?date=' + encodeURIComponent(moment(vm.startDate, 'DD-MM-YYYY').format('YYYYMMDD') + ';' + moment(vm.endDate, 'DD-MM-YYYY').format('YYYYMMDD')))
        .then(
          (response) => {
            console.log(response)
            event.success(response.data)
          }
        )
    },
    exportData () {
      // 20170801;20170803;+0700
      var today = new Date()
      var start = moment(this.startDate, 'DD-MM-YYYY').format('YYYYMMDD')
      var end = moment(this.endDate, 'DD-MM-YYYY').format('YYYYMMDD')
      var tz = parseInt((moment(today).utcOffset() / 60).toString())
      var tzStr = ''
      if (tz > 0) {
        tzStr += '+'
      } else {
        if (tz < 0) {
          tzStr += '-'
        }
      }
      if (tz < 10) {
        tzStr += '0' + tz.toString() + '00'
      } else {
        tzStr += tz.toString() + '00'
      }
      this.axios.get('api/report/sales/export/?date=' + encodeURIComponent(start + ';' + end + ';' + tzStr), { responseType: 'arraybuffer' })
        .then(
          (response) => {
            var blob = new Blob([response.data], { type: response.headers['content-type'] })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Sales Report ' + start + '-' + end + '.xls'
            link.click()
          }
        )
        .catch(
          (error) => {
            console.log(error.response)
          }
        )
    }
  }
}
</script>

<style>
  .hidden-on-narrow {
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/SalesReport.vue